const GOOGLE_SEARCH = 'https://www.google.com/search';
const GOOGLE_AI_MODE_HOME = 'https://www.google.com/ai';

/** Returns null for a blank query so callers can treat it as a no-op. */
export function googleSearchUrl(query: string): string | null {
  const q = query.trim();
  if (!q) return null;
  return `${GOOGLE_SEARCH}?${new URLSearchParams({ q })}`;
}

// `udm=50` is Google's undocumented AI Mode switch; `google.com/ai` is the official entry point.
export function googleAiModeUrl(query: string): string {
  const q = query.trim();
  if (!q) return GOOGLE_AI_MODE_HOME;
  return `${GOOGLE_SEARCH}?${new URLSearchParams({ udm: '50', q })}`;
}
